import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';

/**
 * Returns the calendar quarter (1-4) for a valid ISO 8601 date or date-time string.
 *
 * Supported inputs:
 * - Date-only: YYYY-MM-DD
 * - Date-time (no tz): YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?
 * - Date-time with tz: YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 *
 * Throws if the input is not a valid ISO date/date-time.
 */
export function getQuarter(input: IsoDate | IsoDateTime | IsoDateTimeTz): number {
  const {month} = deconstructDate(input);
  if(!month)
    throw new Error('getQuarter: invalid ISO date/date-time string');
  return Math.ceil(month / 3);
}
